(function () {
  'use strict';

  var SECTION_SELECTOR = '.oddit-section-editorial-card-carousel';
  var sectionState = new Map();

  function debounce(fn, wait) {
    var timeoutId = null;
    var debounced = function () {
      var args = arguments;
      var ctx = this;
      clearTimeout(timeoutId);
      timeoutId = setTimeout(function () {
        fn.apply(ctx, args);
      }, wait);
    };
    debounced.cancel = function () {
      clearTimeout(timeoutId);
      timeoutId = null;
    };
    return debounced;
  }

  function getScrollPad(track) {
    var cs = window.getComputedStyle(track);
    var pad = parseFloat(cs.scrollPaddingLeft);
    if (isNaN(pad)) pad = parseFloat(cs.paddingLeft);
    return isNaN(pad) ? 0 : pad;
  }

  function getCurrentIndex(track, cards) {
    if (!track || !cards.length) return 0;
    var pad = getScrollPad(track);
    var scrollLeft = track.scrollLeft;
    var closest = 0;
    var closestDist = Infinity;
    for (var i = 0; i < cards.length; i++) {
      var dist = Math.abs((cards[i].offsetLeft - pad) - scrollLeft);
      if (dist < closestDist) {
        closestDist = dist;
        closest = i;
      }
    }
    return closest;
  }

  function scrollToIndex(track, cards, index) {
    if (!track || !cards[index]) return;
    var target = cards[index];
    track.scrollTo({
      left: Math.max(0, target.offsetLeft - getScrollPad(track)),
      behavior: 'smooth'
    });
  }

  function updateIndicators(indicators, index) {
    for (var i = 0; i < indicators.length; i++) {
      if (i === index) {
        indicators[i].classList.add('oddit-section-editorial-card-carousel__indicator--active');
        indicators[i].setAttribute('aria-selected', 'true');
      } else {
        indicators[i].classList.remove('oddit-section-editorial-card-carousel__indicator--active');
        indicators[i].setAttribute('aria-selected', 'false');
      }
    }
  }

  function updateNavStates(prevBtn, nextBtn, index, total) {
    if (prevBtn) prevBtn.disabled = index <= 0;
    if (nextBtn) nextBtn.disabled = index >= total - 1;
  }

  function initSection(section) {
    if (!section || sectionState.has(section)) return;

    var track = section.querySelector('.oddit-section-editorial-card-carousel__track');
    var cards = Array.prototype.slice.call(
      section.querySelectorAll('.oddit-section-editorial-card-carousel__card')
    );
    var prevBtn = section.querySelector('.oddit-section-editorial-card-carousel__nav--prev');
    var nextBtn = section.querySelector('.oddit-section-editorial-card-carousel__nav--next');
    var indicators = Array.prototype.slice.call(
      section.querySelectorAll('.oddit-section-editorial-card-carousel__indicator')
    );

    if (!track || !cards.length) return;

    var state = {
      track: track,
      cards: cards,
      prevBtn: prevBtn,
      nextBtn: nextBtn,
      indicators: indicators,
      currentIndex: 0,
      autoplay: null,
      handlers: {}
    };

    function goToIndex(index) {
      var clamped = Math.max(0, Math.min(cards.length - 1, index));
      state.currentIndex = clamped;
      scrollToIndex(track, cards, clamped);
      updateIndicators(indicators, clamped);
      updateNavStates(prevBtn, nextBtn, clamped, cards.length);
    }

    function handlePrev() {
      goToIndex(state.currentIndex - 1);
      if (state.autoplay) state.autoplay.disableAutoplayPermanently();
    }

    function handleNext() {
      goToIndex(state.currentIndex + 1);
      if (state.autoplay) state.autoplay.disableAutoplayPermanently();
    }

    function handleIndicatorClick(index) {
      return function () {
        goToIndex(index);
        if (state.autoplay) state.autoplay.disableAutoplayPermanently();
      };
    }

    var syncActive = debounce(function () {
      var idx = getCurrentIndex(track, cards);
      state.currentIndex = idx;
      updateIndicators(indicators, idx);
      updateNavStates(prevBtn, nextBtn, idx, cards.length);
    }, 100);

    function handleScroll() {
      syncActive();
    }

    if (prevBtn) prevBtn.addEventListener('click', handlePrev);
    if (nextBtn) nextBtn.addEventListener('click', handleNext);

    for (var i = 0; i < indicators.length; i++) {
      indicators[i].addEventListener('click', handleIndicatorClick(i));
    }

    track.addEventListener('scroll', handleScroll, { passive: true });

    state.drag = initDrag(track, function () {
      if (state.autoplay) state.autoplay.disableAutoplayPermanently();
    });

    state.handlers.prev = handlePrev;
    state.handlers.next = handleNext;
    state.handlers.scroll = handleScroll;
    state.handlers.syncActive = syncActive;

    // Initialize
    updateIndicators(indicators, 0);
    updateNavStates(prevBtn, nextBtn, 0, cards.length);

    // Autoplay setup (RAF-based, opt-in via data attribute)
    state.autoplay = initAutoplay(section, function () {
      var next = state.currentIndex + 1 >= cards.length ? 0 : state.currentIndex + 1;
      goToIndex(next);
    });

    sectionState.set(section, state);
  }

  function initDrag(track, onDragInteract) {
    var isDown = false;
    var startX = 0;
    var startScroll = 0;
    var moved = false;
    var activePointer = null;

    function onPointerDown(e) {
      // Mouse / pen only — touch keeps native momentum scrolling.
      if (e.pointerType === 'touch') return;
      if (e.button != null && e.button !== 0) return;
      isDown = true;
      moved = false;
      activePointer = e.pointerId;
      startX = e.clientX;
      startScroll = track.scrollLeft;
      track.classList.add('oddit-section-editorial-card-carousel__track--dragging');
      if (track.setPointerCapture) track.setPointerCapture(e.pointerId);
    }

    function onPointerMove(e) {
      if (!isDown || e.pointerId !== activePointer) return;
      var dx = e.clientX - startX;
      if (Math.abs(dx) > 3) moved = true;
      track.scrollLeft = startScroll - dx;
      e.preventDefault();
    }

    function endDrag(e) {
      if (!isDown || (e && e.pointerId !== activePointer)) return;
      isDown = false;
      activePointer = null;
      track.classList.remove('oddit-section-editorial-card-carousel__track--dragging');
      if (moved && onDragInteract) onDragInteract();
    }

    function onClickCapture(e) {
      // Swallow the click that ends a drag so cards/links don't fire.
      if (moved) {
        e.preventDefault();
        e.stopPropagation();
        moved = false;
      }
    }

    track.addEventListener('pointerdown', onPointerDown);
    track.addEventListener('pointermove', onPointerMove);
    track.addEventListener('pointerup', endDrag);
    track.addEventListener('pointercancel', endDrag);
    track.addEventListener('click', onClickCapture, true);

    return {
      destroy: function () {
        track.removeEventListener('pointerdown', onPointerDown);
        track.removeEventListener('pointermove', onPointerMove);
        track.removeEventListener('pointerup', endDrag);
        track.removeEventListener('pointercancel', endDrag);
        track.removeEventListener('click', onClickCapture, true);
      }
    };
  }

  function initAutoplay(section, advance) {
    var autoplayEnabled = section.dataset.autoplay === 'true';
    if (!autoplayEnabled) {
      return {
        start: function () {},
        stop: function () {},
        destroy: function () {},
        disableAutoplayPermanently: function () {}
      };
    }

    var speedSeconds = parseInt(section.dataset.autoplaySpeed, 10) || 5;
    var intervalMs = speedSeconds * 1000;

    var rafId = null;
    var lastAdvance = performance.now();
    var userHasTakenControl = false;
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function disableAutoplayPermanently() {
      if (userHasTakenControl) return;
      userHasTakenControl = true;
      stop();
    }

    function tick(now) {
      if (userHasTakenControl) return;
      if (now - lastAdvance >= intervalMs) {
        advance();
        lastAdvance = now;
      }
      rafId = requestAnimationFrame(tick);
    }

    function start() {
      if (userHasTakenControl) return;
      if (rafId) return;
      lastAdvance = performance.now();
      rafId = requestAnimationFrame(tick);
    }

    function stop() {
      if (rafId) cancelAnimationFrame(rafId);
      rafId = null;
    }

    if (reducedMotion.matches) {
      return {
        start: function () {},
        stop: function () {},
        destroy: function () {},
        disableAutoplayPermanently: function () {}
      };
    }

    var onVisibilityChange = function () {
      if (userHasTakenControl) return;
      document.hidden ? stop() : start();
    };
    document.addEventListener('visibilitychange', onVisibilityChange);

    var track = section.querySelector('.oddit-section-editorial-card-carousel__track');
    var onMouseEnter = function () { if (!userHasTakenControl) stop(); };
    var onMouseLeave = function () { if (!userHasTakenControl) start(); };
    var onTouchStart = disableAutoplayPermanently;
    var onFocusIn = disableAutoplayPermanently;

    if (track) {
      track.addEventListener('mouseenter', onMouseEnter);
      track.addEventListener('mouseleave', onMouseLeave);
      track.addEventListener('touchstart', onTouchStart, { passive: true });
      track.addEventListener('focusin', onFocusIn);
    }

    var onReducedMotionChange = function (e) {
      if (userHasTakenControl) return;
      e.matches ? stop() : start();
    };
    if (reducedMotion.addEventListener) {
      reducedMotion.addEventListener('change', onReducedMotionChange);
    }

    start();

    return {
      start: start,
      stop: stop,
      disableAutoplayPermanently: disableAutoplayPermanently,
      destroy: function () {
        stop();
        document.removeEventListener('visibilitychange', onVisibilityChange);
        if (track) {
          track.removeEventListener('mouseenter', onMouseEnter);
          track.removeEventListener('mouseleave', onMouseLeave);
          track.removeEventListener('touchstart', onTouchStart);
          track.removeEventListener('focusin', onFocusIn);
        }
        if (reducedMotion.removeEventListener) {
          reducedMotion.removeEventListener('change', onReducedMotionChange);
        }
      }
    };
  }

  function destroySection(section) {
    var state = sectionState.get(section);
    if (!state) return;
    if (state.autoplay) state.autoplay.destroy();
    if (state.drag) state.drag.destroy();
    if (state.handlers.syncActive && state.handlers.syncActive.cancel) {
      state.handlers.syncActive.cancel();
    }
    if (state.track && state.handlers.scroll) {
      state.track.removeEventListener('scroll', state.handlers.scroll);
    }
    sectionState.delete(section);
  }

  function initAll(root) {
    var scope = root || document;
    var sections = scope.querySelectorAll(SECTION_SELECTOR);
    for (var i = 0; i < sections.length; i++) {
      initSection(sections[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var sec = e.target.querySelector ? e.target.querySelector(SECTION_SELECTOR) : null;
    if (sec) initSection(sec);
  });

  document.addEventListener('shopify:section:unload', function (e) {
    var sec = e.target.querySelector ? e.target.querySelector(SECTION_SELECTOR) : null;
    if (sec) destroySection(sec);
  });
})();